import React, { Component, useState, useEffect } from "react";
import {
  Link,
  Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import { connect } from "react-redux";
// layout components
import { withStyles } from '@material-ui/core/styles';
import ReduxThemeProvider from "../theme";
// local components
import { history } from "../helpers";
import {
  NotificationLinksPage,
  AdminPage,
  HomePage,
  SignUpPage,
  HandoutsPage,
  Onboarding,
} from "../views";
import {ProfilePage, ForgotPassword, ForgotPasswordSuccess} from "../views/index";
import IsLoggedInCheck from "../views/IsLoggedInCheck/IsLoggedInCheck";
import { Auth, Header } from "../components";
import PrivateRoute from "../components/PrivateRoute";
import {makeStyles} from "@material-ui/core";
import API from "../helpers/apiHelpers"
import {useIntercom} from "../hooks/useIntercom";

const useStyles = makeStyles((theme) => ({
  app: {
    display: "flex",
    flexDirection: "column" as "column",
    width: "100%"
  },
  vettieTitle : {
    fontFamily: 'Poppins Bold',
    height:'36px',
    fontSize: '26px',
  },
  button: {
    fontSize: 16,
    fontWeight: 600,
    color: "#273878"
  },
  link: {
    fontSize: 18,
    fontWeight: 600,
    textDecoration: "none !important",
    color: "black !important",
    marginLeft: 20
  },
  linkText:{
    textDecoration: "none !important",
    color: "black !important"
  },
  toolbar: {
    justifyContent: "space-between",
    marginLeft: 30,
    marginRight: 30
  },
  mainView: {
    width: "100%"
  },
  drawerPaper:{
    width:"inherit",
    textDecoration: 'none',
    color:'black'
  }
}));

interface Alert {
  type: string,
  message: string
}

interface Authh {
  isAdmin: boolean,
  loggedIn: boolean,
  onboarded: boolean
}

interface Props {
  dispatch: any,
  alert: Alert,
  authentication: Authh,
  classes: any,
}

interface State {
  alert: Alert,
  authentication: Authh
}

interface AppState {
  menuState: HTMLElement | null,
  drawerOpen: boolean,
  isOnBoarding: boolean,
}

const App = () => {
  const classes = useStyles();
  const [menuState,setMenuState] = useState(null);
  const [drawerOpen,setDrawerOpen] = useState(false);
  const [isOnBoarding, setIsOnBoarding] = useState(!!document.cookie.replace(/(?:(?:^|.*;\s*)isOnBoarding\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
  const [isSquareRedirect,setIsSquareRedirect] = useState(false);

  const handleHamburgerClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setDrawerOpen(!drawerOpen)
  }
  useIntercom();
  useEffect(() => {
    API.getSquareoauth()
        .then((res) => {
            setIsOnBoarding(false)
        })
        .catch(() => {
            setIsOnBoarding(true)
        });
},[]);

  useEffect(() => {
    if (window.location.pathname.includes('/success')) {
      setIsSquareRedirect(true)
    }
}, []);
return(
  <div className={classes.app}>
    <ReduxThemeProvider>
    <Router history={history}>
      <Header/>
      <div className={classes.mainView}>
        <Switch>
          <PrivateRoute exact path="/">
            { isOnBoarding ? <Onboarding/> : isSquareRedirect ? <NotificationLinksPage/> : <NotificationLinksPage/>}
          </PrivateRoute>
          <PrivateRoute exact path="/notificationLinks">
            <NotificationLinksPage/>
          </PrivateRoute>
          <PrivateRoute exact path="/profile">
            <ProfilePage/>
          </PrivateRoute>
          <PrivateRoute exact path="/onboarding">
            <Onboarding/>
          </PrivateRoute>
          <PrivateRoute exact path="/success">
            <Redirect to={{pathname: "/onboarding", state: {step: 2} }}/>
          </PrivateRoute>
          <PrivateRoute exact path="/deny">
            <Redirect to={{
              pathname: "/onboarding",
              state:
                  {
                    step: 1,
                    message: "You will not be able to receive payment for appointments because you denied the platform " +
                        "access to your Square account. Please contact support for next steps.",
                    error: true,
                  }
            }}/>
          </PrivateRoute>
          <PrivateRoute exact path="/failure">
            <Redirect to={{
              pathname: "/onboarding",
              state: {
                step: 1,
                message: "Something went wrong. Please try again.",
                error: true,
              },
            }}/>
          </PrivateRoute>
          <PrivateRoute exact path="/handouts">
            <HandoutsPage/>
          </PrivateRoute>
          <PrivateRoute exact path="/admin">
            <AdminPage/>
          </PrivateRoute>
          <PrivateRoute exact path="/resources">
            <HomePage/>
          </PrivateRoute>
          <Route path="/forgotPasswordSuccess">
            <Auth>
              <ForgotPasswordSuccess/>
            </Auth>
          </Route>
          <Route path="/forgotPassword">
            <Auth>
              <ForgotPassword/>
            </Auth>
          </Route>
          <Route exact path="/login">
            <Auth>
              <IsLoggedInCheck />
            </Auth>
          </Route>
          <Route exact path="/signUp">
            <Auth>
              <SignUpPage/>
            </Auth>
          </Route>
        </Switch>
      </div>
    </Router>
    </ReduxThemeProvider>
  </div>
);

}

const mapStateToProps = (state: State) => {
  const { alert, authentication } = state;
  return { alert, authentication };
}

const connectedApp = connect(mapStateToProps)(withStyles(useStyles)(App));
export { connectedApp as App };
export default App;
